import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GaugeIcon } from 'lucide-react';
import { SCORING_HASH } from './QuickScoringPanel';

/** Botón "SCORING RÁPIDO": es un link (#scoring-rapido) que abre el panel flotante en la página actual. */
export function QuickScoringButton({
  className = 'btn btn-metal h-12 px-6'
}: {
  className?: string;
}) {
  const {
    pathname,
    search
  } = useLocation();
  return <Link to={{
    pathname,
    search,
    hash: SCORING_HASH
  }} className={className} data-id="element-506" data-mp="312mdtj52cxw8">
      <GaugeIcon className="h-4 w-4" aria-hidden data-id="element-507" data-mp="2x2vpdm30etuv" />
      SCORING RÁPIDO
    </Link>;
}